import React from "react";
import { useTranslation } from "react-i18next";
import RuleBodyPage from "components/common/RuleBodyPage";
import { RuleModalBodyProps } from "components/common/RuleModal";

function FightSimulatorRuleBody({ page }: RuleModalBodyProps) {
  const { t } = useTranslation();
  const rules = t("FightSimulator.rules", { returnObjects: true }) as string[];

  const phaseContainer =
    "flex items-center gap-3 p-3 bg-gray-800 rounded-lg mb-4";
  const iconContainer =
    "w-8 h-8 min-w-9 min-h-9 flex items-center justify-center rounded-full text-sm";

  return (
    <div className="relative flex">
      {/* Page 0: 사용 방법 */}
      <RuleBodyPage show={page === 0}>
        <div className="space-y-4">
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-red-600`}>
              <i className="fas fa-user" />
            </div>
            <div>
              <div className="font-medium text-red-300 mb-1">{rules[0]}</div>
              <div className="text-sm text-gray-300">{rules[1]}</div>
            </div>
          </div>

          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-blue-600`}>
              <i className="fas fa-user" />
            </div>
            <div>
              <div className="font-medium text-blue-300 mb-1">{rules[2]}</div>
              <div className="text-sm text-gray-300">{rules[3]}</div>
            </div>
          </div>

          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-orange-600`}>
              <i className="fas fa-fist-raised" />
            </div>
            <div>
              <div className="font-medium text-orange-300 mb-1">{rules[4]}</div>
              <div className="text-sm text-gray-300">{rules[5]}</div>
            </div>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 1: 입력 항목 및 주의사항 */}
      <RuleBodyPage show={page === 1}>
        <div className="space-y-4">
          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <div className="font-medium text-green-300 mb-2">{rules[6]}</div>
            <ul className="list-disc list-inside space-y-1 text-sm text-green-200">
              <li>{rules[7]}</li>
              <li>{rules[8]}</li>
              <li>{rules[9]}</li>
              <li>{rules[10]}</li>
            </ul>
          </div>

          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-yellow-600`}>
              <i className="fas fa-exclamation-triangle" />
            </div>
            <div>
              <div className="font-medium text-yellow-300 mb-1">{rules[11]}</div>
              <div className="text-sm text-gray-300">{rules[12]}</div>
            </div>
          </div>
        </div>
      </RuleBodyPage>
    </div>
  );
}

export default FightSimulatorRuleBody;
